import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import parse from 'html-react-parser'

interface Nodes {
  slug: string
  title: string
  date: string
  snippet: string
  description: string
  alt: string
  width: number
  height: number
  image: {
    url: string
  }[]
}

const s = {
  container: `w-full h-fit-content`,
  title: `-mt-4 mb-12 text-h2`,

  card: `flex flex-col mb-20 mdx:last:mb-0`,
  link: `w-full h-full flexcenter flex-col underline transition-all delay-300 ease-out duration-500 hover:underlinered smx:flex-col`,

  image: `w-full h-h32 object-cover mdm:h-h50 smm:h-h40 xsx:h-h32`,

  body: `w-full h-fit-content flex flex-col pt-12 text-black`,
  subtitle: `-mt-4 mb-0 text-3xl`,
  date: `mb-4 text-sm`,
  description: `text-lg leading-10`,
}

const Random = () => {
  const [randomPost, setRandomPost] = useState([])
  const datas = useStaticQuery(graphql`
    query {
      allFlamelinkPostContent(limit: 3, sort: { fields: date, order: DESC }) {
        nodes {
          slug
          title
          date(formatString: "DD MMMM YYYY")
          snippet
          description
          alt
          width
          height
          image {
            url
          }
        }
      }
    }
  `)

  const posts = datas.allFlamelinkPostContent.nodes

  useEffect(() => {
    setRandomPost(posts.sort(() => Math.random() - 0.5))
  }, [])

  // if (randomPost === undefined) return

  return (
    <section className={s.container}>
      <h3 className={s.title}>More News</h3>

      {randomPost.map(
        (
          { slug, title, date, snippet, alt, width, height, image }: Nodes,
          id: React.Key | null | undefined
        ) => (
          <div key={id} className={s.card}>
            <Link className={s.link} to={`/post/${slug}/`}>
              <img
                className={s.image}
                src={image[0].url}
                alt={alt}
                width={width}
                height={height}
              />
              <div className={s.body}>
                <h3 className={s.subtitle}>{title}</h3>
                <p className={s.date}>{date}</p>
                <p className={s.description}>{parse(snippet)}</p>
              </div>
            </Link>
          </div>
        )
      )}
    </section>
  )
}

export default Random
